import { IPaginationParams } from './shared.dto';
import { IUserDetailsDTO } from './users.dao';

abstract class IAccountUsersDAO {
    public abstract getAccountUsers(params: IPaginationParams & {accountId: number}): Promise<IAccountUsersListDTOInternal>;
    public abstract getAccountUsersCSV(params: IPaginationParams & {accountId: number}): Promise<void>;
}

type IAccountUsersDTO = Omit<IUserDetailsDTO, 'accountGroups' | 'confirmationEmailPasswordTrigger' | 'active'>;

interface IAccountUsersListDTOInternal {
    content: IAccountUsersDTO[];
    totalElements: number;
}

export {
    IAccountUsersDAO,
    IAccountUsersDTO,
    IAccountUsersListDTOInternal
};
